import { isAdaptiveuBrand } from '../helpers/brands';

export const HIPAA_ID = '95615';

export const PAYMENT_TYPES = {
  CC: 'CC',
  ACH: 'ACH',
};

export const SIGNUP_TYPES = {
  PAID_SIGNUP: 'paid',
  FREE_SIGNUP: 'free',
  NO_CARD_SIGNUP: 'noCardSignup',
  UPGRADE: 'upgrade',
};

export const FORM_ERROR_MESSAGES = {
  fullName: {
    containsForBiddenWords:
      'Uh-oh, this name doesn’t comply with our Terms of Use',
  },
  email: {
    containsForBiddenWords:
      'Uh-oh, this email doesn’t comply with our Terms of Use',
    alreadyExists:
      'This email address is unavailable. Please try a different address.',
  },
};

export const SIGNUP_EVENTS = {
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  RECAPTCHA_FAILED: 'RECAPTCHA_FAILED',
  FULLCONTACTS_EMPTY_SUBSCRIPTION_RESPONSE: 'FULLCONTACTS_EMPTY_SUBSCRIPTION_RESPONSE',
  JBILLING_EMPTY_PAYMENT_RESPONSE: 'JBILLING_EMPTY_PAYMENT_RESPONSE',
  BRAIN_TREE_ERROR: 'BRAIN_TREE_ERROR',
  SESSION_DOES_NOT_EXIST: 'SESSION_DOES_NOT_EXIST',
  INCORRECT_USER_ID: 'INCORRECT_USER_ID',
  INCORRECT_DEAL_ID: 'INCORRECT_DEAL_ID',
  INCORRECT_LEAD_ID: 'INCORRECT_LEAD_ID',
  MISSING_LEAD_OR_DEAL_ID: 'MISSING_LEAD_OR_DEAL_ID',
  BRAND_ID_MISMATCH_FOR_DEAL_OR_LEAD: 'BRAND_ID_MISMATCH_FOR_DEAL_OR_LEAD',
  BRAIN_TREE_CLIENT_TOKEN_ERROR: 'BRAIN_TREE_CLIENT_TOKEN_ERROR',
  PLANS_NOT_AVAILABLE: 'PLANS_NOT_AVAILABLE',
  DEFAULT_EVENT: 'DEFAULT_EVENT',
  UNAUTHORISED_UPGRADE_ERROR: 'UNAUTHORISED_UPGRADE_ERROR',
  EMAIL_ADDRESS_UNAVAILABLE: 'EMAIL_ADDRESS_UNAVAILABLE',
  RATELIMIT_EXCEEDED: 'RATELIMIT_EXCEEDED',
};

const INCORRECT_USER_ID_ERROR_HEADER = "Hmm, there's been a glitch.";
const INCORRECT_USER_ID_ERROR_MESSAGE = "Your sign-up details couldn't be loaded. Please contact us for help.";

export const FAILURE_MESSAGE_BY_EVENT = {
  SIGNUP: {
    ERROR_HEADER: 'Sign-up unsuccessful',
    DEFAULT_EVENT: {
      header: 'Sign-up unsuccessful',
      message:
        "Unfortunately, your account couldn't be created. Please refresh this page and try again. If you encounter the same error, contact us for help.",
    },
    BRAIN_TREE_ERROR: {
      header: 'Sign-up unsuccessful',
      message:
        "Unfortunately, your account couldn't be created. Please refresh this page and try again. If you encounter the same error, contact us for help.",
    },
    SESSION_DOES_NOT_EXIST: {
      header: 'Sign-up unsuccessful',
      message:
        "Unfortunately, your account couldn't be created. Please refresh this page and try again. If you encounter the same error, contact us for help.",
      analyticsMessage: 'User session expired.',
    },
    INTERNAL_SERVER_ERROR: {
      header: 'Sign-up unsuccessful',
      message:
        "Unfortunately, your account couldn't be created due to a server issue. Please try again later. If you encounter the same error, contact us for help.",
    },
    RECAPTCHA_FAILED: {
      header: 'Sign-up unsuccessful',
      message:
        'Additional authentication is required to complete this transaction. Please try again later.',
    },
    RATELIMIT_EXCEEDED: {
      header: 'Sign-up unsuccessful',
      message:
        "Unfortunately, your account couldn't be created due to a server issue. Please try again later. If you encounter the same error, contact us for help.",
    },
    JBILLING_EMPTY_PAYMENT_RESPONSE: {
      header: 'Sign-up unsuccessful',
      message:
        "Unfortunately, your account couldn't be created due to a server issue. Please try again later. If you encounter the same error, contact us for help.",
    },
    FULLCONTACTS_EMPTY_SUBSCRIPTION_RESPONSE: {
      header: 'Sign-up unsuccessful',
      message:
        "Unfortunately, your account couldn't be created due to a server issue. Please try again later. If you encounter the same error, contact us for help.",
    },
    INCORRECT_USER_ID: {
      header: INCORRECT_USER_ID_ERROR_HEADER,
      message: INCORRECT_USER_ID_ERROR_MESSAGE,
      analyticsMessage:
        'DealId/LeadId is invalid or has been converted to an account.',
    },
    INCORRECT_DEAL_ID: {
      header: INCORRECT_USER_ID_ERROR_HEADER,
      message: INCORRECT_USER_ID_ERROR_MESSAGE,
      analyticsMessage: 'Invalid DealId.',
    },
    INCORRECT_LEAD_ID: {
      header: INCORRECT_USER_ID_ERROR_HEADER,
      message: INCORRECT_USER_ID_ERROR_MESSAGE,
      analyticsMessage: 'Invalid LeadId.',
    },
    MISSING_LEAD_OR_DEAL_ID: {
      header: INCORRECT_USER_ID_ERROR_HEADER,
      message: INCORRECT_USER_ID_ERROR_MESSAGE,
      analyticsMessage: 'LeadId/DealId is missing in signup url.',
    },
    BRAND_ID_MISMATCH_FOR_DEAL_OR_LEAD: {
      header: INCORRECT_USER_ID_ERROR_HEADER,
      message: INCORRECT_USER_ID_ERROR_MESSAGE,
      analyticsMessage:
        'BrandId does not match with DealId/LeadId in signup url.',
    },
    BRAIN_TREE_CLIENT_TOKEN_ERROR: {
      header: "Hmm, there's been a glitch.",
      message:
        "Your sign-up details couldn't be loaded. Please contact us for help.",
    },
    PLANS_NOT_AVAILABLE: {
      header: "Hmm, there's been a hiccup.",
      message:
        'This may be a one-off error, so please refresh the page and try again.  If you encounter the same error, contact us for help.',
    },
    EMAIL_ADDRESS_UNAVAILABLE: {
      header: 'Sign-up unsuccessful',
      message: FORM_ERROR_MESSAGES.email.alreadyExists,
    },
  },
  UPGRADE: {
    ERROR_HEADER: 'Payment unsuccessful',
    DEFAULT_EVENT: {
      header: 'Payment unsuccessful',
      message: 'Unable to set up a payment profile. Please contact us for help.',
    },
    BRAIN_TREE_ERROR: {
      header: 'Payment unsuccessful',
      message:
        "Unfortunately, your plan couldn't be updated. Please refresh this page and try again. If you encounter the same error, contact us for help.",
    },
    SESSION_DOES_NOT_EXIST: {
      header: 'Payment unsuccessful',
      message:
        "Unfortunately, your plan couldn't be updated. Please refresh this page and try again. If you encounter the same error, contact us for help.",
      analyticsMessage: 'User session expired.',
    },
    INTERNAL_SERVER_ERROR: {
      header: 'Payment unsuccessful',
      message:
        "Unfortunately, your plan couldn't be updated due to a server issue. Please try again later. If you encounter the same error, contact us for help.",
    },
    RECAPTCHA_FAILED: {
      header: 'Payment unsuccessful',
      message:
        'Additional authentication is required to complete this transaction. Please try again later.',
    },
    RATELIMIT_EXCEEDED: {
      header: 'Payment unsuccessful',
      message:
        "Unfortunately, your plan couldn't be updated due to a server issue. Please try again later. If you encounter the same error, contact us for help.",
    },
    JBILLING_EMPTY_PAYMENT_RESPONSE: {
      header: 'Payment unsuccessful',
      message:
        "Unfortunately, your plan couldn't be updated due to a server issue. Please try again later. If you encounter the same error, contact us for help.",
    },
    INCORRECT_USER_ID: {
      header: "Hmm, there's been a glitch.",
      message:
        "Your plan details couldn't be loaded. Please contact us for help.",
      analyticsMessage: 'Invalid accountId.',
    },
    BRAIN_TREE_CLIENT_TOKEN_ERROR: {
      header: "Hmm, there's been a glitch.",
      message:
        "Your plan details couldn't be loaded. Please contact us for help.",
    },
    PLANS_NOT_AVAILABLE: {
      header: "Hmm, there's been a hiccup.",
      message:
        'This may be a one-off error, so please refresh the page and try again.  If you encounter the same error, contact us for help.',
    },
    UNAUTHORISED_UPGRADE_ERROR: {
      header: 'Owner or admin access required',
      message:
        'Please contact the owner or an admin to upgrade this account.',
    },
  },
};

export const PLANS_INITIAL_STATE_LITERAL = 'plansInitialState';

export const PROVINCE_LITERAL = 'province';

export const ANYTIME_CONTACT_FIELDS = {
  fullName: {
    label: 'Full name',
    errorMsg: 'Please enter a valid name',
    placeholder: 'First and last name',
  },
  companyName: {
    label: 'Company name',
    errorMsg: 'Please enter a valid company name',
    placeholder: 'Your company name',
  },
  phoneNumber: {
    label: 'Phone',
    errorMsg: 'Please enter a valid phone number',
    placeholder: 'Your phone number',
  },
  email: {
    label: 'Email',
    errorMsg: 'Enter valid email address',
    placeholder: 'name@domain.com',
  },
  password: {
    label: 'Password',
    errorMsg:
        'Password must contain at least one letter, one number & 8 characters',
    placeholder: 'At least 8 characters',
  },
};

export const COMMON_CONTACT_FIELDS = {
  fullName: {
    label: 'Full Name',
    errorMsg: 'Enter valid name',
    placeholder: 'First and last name',
  },
  companyName: {
    label: 'Company Name',
    errorMsg: 'Enter valid company name',
    placeholder: 'Your company name',
  },
  phoneNumber: {
    label: 'Phone',
    errorMsg: 'Enter valid phone number',
    placeholder: 'Your phone number',
  },
  email: {
    label: 'Email',
    errorMsg: 'Enter valid email address',
    placeholder: 'name@domain.com',
  },
  password: {
    label: 'Password',
    errorMsg:
        'Password must contain at least one letter, one number & 8 characters',
    placeholder: 'At least 8 characters',
  },
};

export const LEXUK_CONTACT_FIELDS = {
  fullName: {
    label: 'Name',
    errorMsg: 'Enter valid name',
    placeholder: 'Name',
  },
  companyName: {
    label: 'Company Name',
    errorMsg: 'Enter valid company name',
    placeholder: 'Company name',
  },
  phoneNumber: {
    label: 'Phone',
    errorMsg: 'Enter valid phone number',
    placeholder: 'Phone number',
  },
  email: {
    label: 'Email',
    errorMsg: 'Enter valid email address',
    placeholder: 'Email',
  },
  password: {
    label: 'Password',
    errorMsg:
        'Password must contain at least one letter, one number & 8 characters',
    placeholder: 'At least 8 characters',
  },
};

export const SETMORE_CONTACT_FIELDS = {
  fullName: {
    label: 'Full Name',
    errorMsg: 'Enter valid name',
    placeholder: 'First and last name',
  },
  companyName: {
    label: 'Company Name',
    errorMsg: 'Enter valid company name',
    placeholder: 'Your company name',
  },
  email: {
    label: 'Email',
    errorMsg: 'Enter valid email address',
    placeholder: 'name@domain.com',
  },
  password: {
    label: 'Password',
    errorMsg:
        'Password must contain at least one letter, one number & 8 characters',
    placeholder: isAdaptiveuBrand
      ? 'Password at least 8 characters'
      : 'At least 8 characters',
  },
};

export const SETMORE_START_NOW_PAGE_CONTACT_FIELDS = {
  fullName: {
    errorMsg: 'Full name required',
    placeholder: 'Full name',
  },
  email: {
    errorMsg: 'Email required',
    placeholder: 'Email',
  },
  password: {
    errorMsg:
        'Password must contain at least one letter, one number & 8 characters',
    placeholder: 'Password',
  },
};

export const CHATSUPPORT_CONTACT_FIELDS = {
  email: {
    label: 'Email',
    errorMsg: 'Enter valid email address',
    placeholder: 'name@domain.com',
  },
  password: {
    label: 'Password',
    errorMsg:
        'Password must contain at least one letter, one number & 8 characters',
    placeholder: 'At least 8 characters',
  },
  phoneNumber: {
    label: 'Phone number (optional)',
    errorMsg: 'Enter valid phone number',
    placeholder: 'Your phone number',
  },
};

export const FORBIDDEN_PHRASES = [
  'call girls',
  'call girl',
  'girls call',
  'girl call',
  'escorts call',
  'call escorts',
  'escorts',
  'escort',
  'girls escorts',
  'escorts girls',
  'call escort',
  'escort call',
  'callgirls',
  'callgirl',
  'callescorts',
  'callescort',
  'escortcall',
];

export const EMAIL_API_STATUS = {
  INPROGRESS: 'inprogress',
  NOT_INPROGRESS: 'not inprogress',
  COMPLETED: 'completed',
};

export const EMAIL_AVAILABILITY_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
};
